import './bhospitalityco1/style';
import FormStructure from './bhospitalityco1/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js